import { io } from 'socket.io-client';
const configValue: string = "https://crm.apple4you.ru" //(process.env.VITE_SOCKET_URL as string);


export const socket = io(configValue);
